import { Controller } from '@hotwired/stimulus'
import { confirmWithDialog } from '../../src/admin/js/turbo-confirm-dialog'

// Asks before saving a change of the session's CC tag that has effects: adding it to a session already over sends the
// attendance attestation emails at once, removing it once they went out stops the reminders.
export default class extends Controller {
  static values = { onMessage: String, offMessage: String }

  connect () {
    this.form = this.element.closest('form')
    this.initialValue = this.checkedValue()
    this.confirmChange = this.confirmChange.bind(this)
    this.form?.addEventListener('submit', this.confirmChange)
  }

  disconnect () {
    this.form?.removeEventListener('submit', this.confirmChange)
  }

  async confirmChange (event) {
    if (this.confirmed) {
      this.confirmed = false
      return
    }

    const value = this.checkedValue()
    if (value === this.initialValue) return

    const message = value === 'true' ? this.onMessageValue : this.offMessageValue
    if (!message) return

    event.preventDefault()
    event.stopImmediatePropagation()
    if (!(await confirmWithDialog(message))) return

    this.confirmed = true
    this.form.requestSubmit(event.submitter)
  }

  checkedValue () {
    return this.element.querySelector('input[type="radio"]:checked')?.value
  }
}
